
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {numeric, required, requiredIf} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {CashboxUpdateFormRequestType} from "@/form/finance/cashbox/CashboxUpdateForm.types";
import { fio, email } from "@/utils/validators";
import {ICashboxListItem} from "@/entity/finance/cashbox/cashbox.types";
import {ICashboxType, CashboxTypeResponseType} from "@/entity/finance/cashbox/cashboxType.types";

@Component
export default class CashboxUpdateForm extends Form{
    id = 0;
    @Validate(required, i18nText("Введите название"))
    name = '';
    @Validate(required, i18nText("Выберите тип кассы2"))
    type = 1;
    comment: string | null = '';
    types: ICashboxType[] = [];
    
    getFormData(): CashboxUpdateFormRequestType {
        return {
            id: this.id,
            name: this.name,
            type: this.type,
            comment: this.comment,
        }
    }
    setFormData(types: ICashboxType[], item: ICashboxListItem): void {
        this.types = [];
        for (let i = 0; i < types.length; i++) {
            if(!this.type){
                this.type = types[i].id;
            }
            this.types.push(types[i]);
        }
        if (item) {
            this.id = item.id;
            this.name = item.name;
            if(item.type){
                this.type = item.type.id;
            }
            this.comment = item.comment;
        }
    }
}
